module.exports = __webpack_public_path__ + "img/img-31.a3672052.png";